/*
 * Content types we consider parseable as a CDA document. Comparison is case-insensitive on the
 * media type only — any `;charset=…` parameter is stripped before matching.
 */
const cdaContentTypesLowerCase = new Set<string>([
  'text/xml',
  'application/xml',
  'text/x-cda',
  'application/cda+xml',
  'application/hl7-cda+xml',
]);

export const isCdaContentType = (contentType: string): boolean => {
  const mediaType = contentType.split(';')[0]?.trim().toLowerCase() ?? '';
  return cdaContentTypesLowerCase.has(mediaType);
};
